<template>
  <div :style="{ height, width }" id="EchartsGG" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },

  setup(props) {
    // const echartsData={
    //     size: 21,
    //     list: [
    //       {  mc: "3.15",  sysl: "2.97" },
    //       {  mc: "3.18", sysl: "2.93" },
    //       {  mc: "3.20", sysl: "2.5" },
    //       { mc: "3.21", sysl: "2.53" },
    //       { mc: "3.22", sysl: "2.53" },
    //       {  mc: "3.25", sysl: "2.9" },
    //       { mc: "3.26", sysl: "2.83" },
    //       { mc: "3.27", sysl: "2.83" },
    //       { mc: "3.28", sysl: "3.00" },
    //       { mc: "4.01", sysl: "2.94" },
    //     ],
    //   }
    onMounted(() => {
      loadEchartsAnimate(props.left2Data);
    });
    function chartsRelativeSize(percent, derection){
        var windowW = this.$refs.docement.offsetWidth;
        var windowH = this.$refs.docement.offsetHeight;
        var r = 0;
        if ("h" === derection) {
          r = (percent * windowH) / 100;
        } else {
          r = (percent * windowW) / 100;
        }
        return r;
      }
    function loadEchartsAnimate(left2Data){
      console.log(left2Data)
      let time = left2Data.time
      let data = left2Data.data
      console.log(time)
        var that = this;
        var echarts = require("echarts");
        var myCharts = echarts.init(document.getElementById("EchartsGG"));
        var option = {
          color: ["#407FFF", "#00FFBA"],
          tooltip: {
            trigger: "axis",
            textStyle: {
              color: "#000",
              fontSize: "40",
            },
          },
          grid: {
            left: "8%",
            right: "8%",
            bottom: "10%",
            top: "15%",
            containLabel: true,
          },
          title: {
            text: "元/公斤", // 替换为您所需的标题文本
            textStyle: {
              color: "#D6FFFF", // 文本颜色
              fontSize: 26, // 字体大小
              // fontWeight: "bold", // 字体粗细
            },
            // left: "right", // 标题水平居中
            top: "7%", // 标题距离顶部的距离，可根据需要调整
            right: "7%",
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              axisLine: {
                show: true,
                onZero: false,
                lineStyle: {
                  color: "#024349",
                },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "rgba(255,255,255,.65)",
                  fontSize: 26,
                },
              },
              data: [],
            },
          ],
          yAxis: {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,.65)",
                fontSize: 24,
              },
              formatter: function(value) {
                // 当值为 0 时不显示标签
                return value === 0 ? '' : value;
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#35414D",
                type: [5, 10],
                dashOffset: 5,
              },
            },
          },
          series: [
            {
              type: "line",
              smooth: true,
              symbolSize: 0.01,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.9, [
                  {
                    offset: 0,
                    color: "rgba(0, 255 ,207,0)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255 ,207,0)",
                  },
                  {
                    offset: 0,
                    color: "rgba(0, 255 ,207,.5)",
                  },
                ]),
              },
              itemStyle: {
                color: "#E3BD5A",
              },
              lineStyle: {
                // 线条加阴影
                // 设置阴影颜色
                // shadowColor: "#3D5DF4",
                shadowColor: "#E3BD5A",
                shadowOffsetX: 0,
                // 设置阴影沿y轴偏移量为9
                shadowOffsetY: 9,
                // 设置阴影的模糊大小
                shadowBlur: 20,
                // 设置线条渐变色
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: "#00FFCF" },
                  // { offset: 0.2, color: "#3D5DF4" },
                  { offset: 0.2, color: "#00FFCF" },
                  { offset: 0.1, color: "#00FFCF" },
                ]),
              },

              emphasis: {
                scale: 1000,
                itemStyle: {
                  color: "#3D5DF4",
                  borderColor: "#FFFFFF",
                  borderWidth: 3,
                  borderType: "solid",
                },
              },
              data: [],
            },
          ],
        };
        for (var i = 0; i < time.length && i < 8; i++) {
          // console.log(left2Data)
          option.xAxis[0].data.push(time[i]);
          option.series[0].data.push(data[i])
          //   option.series[1].data.push(leftData.list[i].dysl);
        }
        myCharts.setOption(option);

        if (window.hbfxInterval) {
          clearInterval(window.hbfxInterval);
        }
        window.hbfxIndex = 0;
        window.hbfxInterval = setInterval(function() {
          option.xAxis[0].data.shift();
          option.xAxis[0].data.push(
            time[window.hbfxIndex % time.length]
          );

          option.series[0].data.shift();
          option.series[0].data.push(
            data[window.hbfxIndex % data.length]
          );

          myCharts.setOption(option);
          window.hbfxIndex++;
        }, 2000);
      }
  }
}
</script>
<style lang="less">
.min-body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #010827;
}
</style>
